/**
 * Constantes para los roles de usuarios en el sistema Bienesys
 * 
 * ROLES:
 * - client: Cliente externo. Acceso solo a calendario y capacidad de cancelar/recuperar sus clases
 * - instructor: Profesor. Ve SUS clases y pasa lista en ellas, nada más
 * - user: Operador/empleado. Acceso a gestión operativa diaria (clientes, calendario, eventos)
 * - admin: Gestor de tenant. Acceso a toda la gestión del tenant (administrativo, reportes, configuración)
 * - superadmin: Gestor de plataforma. Acceso total al sistema incluyendo gestión de tenants
 */

export const ROLES = {
  CLIENT: 'client',
  INSTRUCTOR: 'instructor',
  USER: 'user',
  ADMIN: 'admin',
  SUPERADMIN: 'superadmin',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];
